import React, { SVGProps } from 'react'

const BigForwardIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={31}
    height={30}
    fill="none"
    {...props}
  >
    <path
      fill="#fff"
      d="m8.875 4.836 1.768-1.767L22.575 15 10.643 26.934l-1.768-1.768 10.163-10.165L8.875 4.836Z"
    />
  </svg>
)
export default BigForwardIcon
